module.exports = __webpack_public_path__ + "static/media/image5.56701fef.png";